'use strict';

module.exports = function _throwOnMissingKey (obj, coveredPath, key, remainingPath) {
  throw new Error(`Missing key in object ${obj} at ${coveredPath.map(String).join('.')}.>>${key}<<.${remainingPath.map(String).join('.')}`);
};



// WEBPACK FOOTER //
// ./lib/rlink-collections/_throwOnMissingKey.js